import {
  Box,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNpfuafLabels } from "../../../redux/npfuafSlice";
import NpfUafPage from "./NpfUafLabelPage";
import { logger } from "../../../utils/logger";

const NpfUafFilterForm = () => {
  const dispatch = useDispatch();
  const [npfuafLabelAddress, setNpfuafLabelAddress] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [status, setStatus] = useState("");
  const [sort, setSort] = useState("");
  const [labelposition, setLabelposition] = useState("top");
  const [loading, setLoading] = useState(false);
  const { user, role } = useSelector((state) => state.auth);

  const handlefilter = async () => {
    try {
      setLoading(true);
      setNpfuafLabelAddress([]);
      setFilterApplied(false);
      const response = await dispatch(fetchNpfuafLabels({ status, sort }));
      if (response && response.payload) {
        if (Array.isArray(response.payload)) {
          setNpfuafLabelAddress(response.payload);
          logger.info("Filter applied successfully", {
            filter: status,
            user,
            role,
            resultCount: response.payload.length,
          });
        } else {
          setNpfuafLabelAddress([]);
          setFilterApplied(true);
          logger.warn("Filter applied but no data found", {
            filter: status,
            user,
            role,
          });
        }
      } else {
        setNpfuafLabelAddress([]);
        setFilterApplied(true);
        logger.warn("Filter applied but no data found", {
          filter: status,
          user,
          role,
        });
      }
    } catch (error) {
      console.error("Error applying filter:", error);
      setNpfuafLabelAddress([]);
      setFilterApplied(true);
      logger.error("Error applying filter", {
        filter: status,
        user,
        role,
        error: error.message,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          marginBottom: 2,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Status</InputLabel>
          <Select
            label="NPF UPF Status"
            name="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            required
          >
            <MenuItem value="complete">Complete</MenuItem>
            <MenuItem value="additional">Additional</MenuItem>
            <MenuItem value="">Select</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Sort</InputLabel>
          <Select
            label="Sort"
            name="sort"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            required
          >
            <MenuItem value="pincode">Pincode</MenuItem>
            <MenuItem value="name">Name</MenuItem>
            <MenuItem value="daywise">Day</MenuItem>
            <MenuItem value="">Select</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          component="fieldset"
          size="small"
          sx={{ minWidth: 120, pl: 1, mr: 2 }}
        >
          <FormLabel component="legend">Label Preference</FormLabel>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>Top</Typography>
            <Switch
              checked={labelposition === "bottom"}
              sx={{ marginTop: 3 }}
              onChange={(e) =>
                setLabelposition(e.target.checked ? "bottom" : "top")
              }
            />
            <Typography>Bottom</Typography>
          </Stack>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          sx={{ marginLeft: 1 }}
          onClick={handlefilter}
        >
          Apply Filter
        </Button>
      </Box>
      {loading && (
        <Box textAlign="center" mt={2}>
          <CircularProgress />
        </Box>
      )}

      {!loading && npfuafLabelAddress.length > 0 ? (
        <NpfUafPage
          data={npfuafLabelAddress}
          type={status}
          labelposition={labelposition}
          username={user}
          role={role}
        />
      ) : !loading && filterApplied && npfuafLabelAddress.length === 0 ? (
        <Box textAlign="center" mt={2} fontWeight="bold" color="black">
          No records found.
        </Box>
      ) : null}
    </>
  );
};

export default NpfUafFilterForm;
